module.exports = __webpack_public_path__ + "img/background-dots-lines-2.315f6b0.jpg";